export enum BreakpointsScope {
  All = 'all',
  Cascades = 'cascades',
  DesktopAndTablet = 'desktopAndTablet',
  Mobile = 'mobile',
}
